import React from "react";
import CategoryPage from "./games/CategoryPage";
import { getGameById } from "../data/gameCatalog";

export default function Spoofer() {
  return <CategoryPage game={getGameById("spoofer")} />;
}
